"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPISODIC_WINDOW_DAYS = void 0;
exports.episodicDeadline = episodicDeadline;
const wasteAccumulation_1 = require("encamp-shared/dist/constants/wasteAccumulation");
Object.defineProperty(exports, "EPISODIC_WINDOW_DAYS", { enumerable: true, get: function () { return wasteAccumulation_1.EPISODIC_WINDOW_DAYS; } });
const date_1 = require("encamp-shared/dist/utils/date");
/** Always exactly `startDate + EPISODIC_WINDOW_DAYS` at UTC midnight; never persisted. */
function episodicDeadline(eventStartDate) {
    return (0, date_1.addUtcDays)((0, date_1.floorToUtcMidnight)(eventStartDate), wasteAccumulation_1.EPISODIC_WINDOW_DAYS);
}
//# sourceMappingURL=window.js.map